module.exports = __webpack_public_path__ + "img/imagen1.d1021829.png";